import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '../styles/startBusiness.module.scss';
import ContactUsModal from './contactUsModal';
import Link from 'next/link';
import { useRouter } from 'next/router';

function StartBusiness({ }) {
    const { t } = useTranslation('common');
    const router = useRouter();

    return <section className={styles.startBusiness}>
        <div className={styles.startBusiness__content}>
            <div className={styles.startBusiness__content__items}>
                <h2>{t('startBusiness.title')}</h2>
                <p>{t('startBusiness.description')}</p>
            </div>
            <div className={styles.startBusiness__buttons}>
                <Link href='/configuration'>
                    <a>
                        <button className='btn cloud'>{t('startBusiness.createCloud')}</button>
                    </a>
                </Link>
                <ContactUsModal lang={router.locale} outlined />
            </div>
        </div>
    </section>
};

export default memo(StartBusiness);
